
/**
 * 坐标系转换函数
 * 1、WGS-84 地心坐标系，即GPS原始坐标体系。在中国，任何一个地图产品都不允许使用GPS坐标，据说是为了保密。GoogleEarth及GPS芯片使用
 * 2、GCJ-02火星坐标系，国测局02年发布的坐标体系，它是一种对经纬度数据的加密算法，即加入随机的偏差。高德、腾讯、Google中国地图使用。国内最广泛使用的坐标体系
 * 3、其他坐标体系：一般都是由GCJ-02进过偏移算法得到的。这种体系就根据每个公司的不同，坐标体系都不一样了。比如，百度的BD-09坐标、搜狗坐标等
 * WGS->GCJ
 * WGS->BD09
 * GCJ->BD09
 * 百度转WGS: 1.百度转GCJ(BD092GCJ)  2.GCJ转WGS(GCJ2WGS) 
 */
export class PointConvertor {
    pointCount: any
    Result: any
    NoisIndex: any
    Time: any
    stepCount: number = 100
    M_PI: any = 3.14159265358979324
    A: any = 6378245.0
    EE: any = 0.00669342162296594323
    X_PI: any = this.M_PI * 3000.0 / 180.0
    // AK: any
    constructor() {
        // this.AK = ak;
        this.pointCount = []
        this.Result = []
        this.NoisIndex = []
        this.Time = new Date()
    }
    outofChina(p: { lng: number, lat: number }): boolean {
        if (p.lng < 72.004 || p.lng > 137.8347) {
            return true
        }
        if (p.lat < 0.8293 || p.lat > 55.8271) {
            return true
        }
        return false
    }
    WGS2GCJ_lat(x: number, y: number): number {
        var ret1 = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
        ret1 += (20.0 * Math.sin(6.0 * x * this.M_PI) + 20.0 * Math.sin(2.0 * x * this.M_PI)) * 2.0 / 3.0
        ret1 += (20.0 * Math.sin(y * this.M_PI) + 40.0 * Math.sin(y / 3.0 * this.M_PI)) * 2.0 / 3.0
        ret1 += (160.0 * Math.sin(y / 12.0 * this.M_PI) + 320 * Math.sin(y * this.M_PI / 30.0)) * 2.0 / 3.0
        return ret1
    }
    WGS2GCJ_lng(x: number, y: number): number {
        var ret2 = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
        ret2 += (20.0 * Math.sin(6.0 * x * this.M_PI) + 20.0 * Math.sin(2.0 * x * this.M_PI)) * 2.0 / 3.0
        ret2 += (20.0 * Math.sin(x * this.M_PI) + 40.0 * Math.sin(x / 3.0 * this.M_PI)) * 2.0 / 3.0
        ret2 += (150.0 * Math.sin(x / 12.0 * this.M_PI) + 300.0 * Math.sin(x / 30.0 * this.M_PI)) * 2.0 / 3.0
        return ret2
    }
    WGS2GCJ(p: { lng: any, lat: any }): { lng: any, lat: any } {
        var poi = { lng: +p.lng, lat: +p.lat }
        if (this.outofChina(poi)) {
            return poi
        }
        var powLng = poi.lng//Math.pow(poi.lng,20)
        var powLat = poi.lat//Math.pow(poi.lng,20)
        var dLat = this.WGS2GCJ_lat(powLng - 105.0, powLat - 35.0)
        var dLon = this.WGS2GCJ_lng(powLng - 105.0, powLat - 35.0)
        var radLat = powLat / 180.0 * this.M_PI
        var magic = Math.sin(radLat)
        magic = 1 - this.EE * magic * magic
        var sqrtMagic = Math.sqrt(magic)
        dLat = (dLat * 180.0) / ((this.A * (1 - this.EE)) / (magic * sqrtMagic) * this.M_PI)
        dLon = (dLon * 180.0) / (this.A / sqrtMagic * Math.cos(radLat) * this.M_PI)
        var poi2 = {
            lat: powLat + dLat,
            lng: powLng + dLon
        }
        return poi2
    }
    GCJ2WGS(poi: { lng: number, lat: number }): { lng: number, lat: number } {
        if (this.outofChina(poi)) {
            return poi
        }
        var dLat = this.WGS2GCJ_lat(poi.lng - 105.0, poi.lat - 35.0)
        var dLon = this.WGS2GCJ_lng(poi.lng - 105.0, poi.lat - 35.0)
        var radLat = poi.lat / 180.0 * this.M_PI
        var magic = Math.sin(radLat)
        magic = 1 - this.EE * magic * magic
        var sqrtMagic = Math.sqrt(magic)
        dLat = (dLat * 180.0) / ((this.A * (1 - this.EE)) / (magic * sqrtMagic) * this.M_PI)
        dLon = (dLon * 180.0) / (this.A / sqrtMagic * Math.cos(radLat) * this.M_PI)
        var poi2 = {
            lat: poi.lat * 2 - poi.lat + dLat,
            lng: poi.lng * 2 - poi.lng + dLon
        }
        return poi2
    }
    GCJ2BD09(poi: { lng: number, lat: number }): { lng: number, lat: number } {
        var x = poi.lng, y = poi.lat
        var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.X_PI)
        var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.X_PI)
        var poi2 = {
            lng: z * Math.cos(theta) + 0.0065,
            lat: z * Math.sin(theta) + 0.006
        }
        return poi2
    }
    BD092GCJ(poi: { lng: number, lat: number }): { lng: number, lat: number } {
        var x = poi.lng - 0.0065, y = poi.lat - 0.006
        var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.X_PI)
        var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.X_PI)
        var poi2 = {
            lng: z * Math.cos(theta),
            lat: z * Math.sin(theta)
        }
        return poi2
    }
    WGS2BD09(poi: { lng: number, lat: number }): { lng: number, lat: number } {
        //WGS->GCJ
        var poi2 = this.WGS2GCJ(poi)
        if (typeof poi2 === "undefined") {
            return poi
        }
        //GCJ->百度坐标系
        return this.GCJ2BD09(poi2)
    }
}